/**
 * Filename → extension. Its own leaf module (no imports) because both
 * `uploadValidation` (React-adjacent) and `@/api/client` need it, and having
 * the API client import the validation module would close an import cycle
 * (uploadValidation → useAppConfigQuery → @/api → client).
 */

/** The basename's extension, lowercased, without the dot ('' when there is none). */
export function fileExtension(filename: string): string {
  const dot = filename.lastIndexOf('.');
  if (dot <= 0 || dot === filename.length - 1) return '';
  return filename.slice(dot + 1).toLowerCase();
}
